// import { useEffect, useState } from "react";
// import Input from "../../../form/Input";
// import useForm from "../../../../hooks/useForm";
// import Button from "../../../form/Button";
// // import { bannerAddEdit } from "../../../../services/bannersService";
// import FileUploadSingle from "../../../form/FileUploadSingle";
// import Textarea from "../../../form/Textarea";
// import { toast } from "react-toastify";
// import Select from "../../../form/select/Select";
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
// import { useDebounce } from "../../../../hooks/useDebounce";
// import { useSelector } from "react-redux";
// import {
//   collectionAddEdit,
//   collectionDetails,
// } from "../../../../services/collectionService";
// import AvatarUpload from "../../../common/AvatarUpload";
// import { initialsValue } from "../../../../helpers";
// import UrlInput from "../../../form/UrlInput";
// import IconSelector from "../../../form/iconSelector/IconSelector";
// import Tabs from "../../../elements/Tabs";
// import { eventList } from "../../../../services/eventService";
// import { organizationList } from "../../../../services/organizationService";

// const validation = {
//   name: { required: true, message: "Name is required" },
// };

// function FormComponent({
//   getResponse = () => {},
//   close = () => {},
//   data,
//   lang,
// }) {
//   const queryClient = useQueryClient();
//   const {
//     values,
//     handleChange,
//     handleSubmit,
//     errors,
//     setFieldsValue,
//     formValidate,
//   } = useForm({
//     validationRules: validation,
//   });

//   const [eventFilters, setEventFilters] = useState({
//     limit: 10,
//     page: 1,
//     sortQuery: "-createdAt",
//   });
//   const [eventKeyword, setEventKeyword] = useState("");
//   const eventSearch = useDebounce(eventKeyword, 300);

//   const [organizerFilters, setOrganizerFilters] = useState({
//     limit: 10,
//     page: 1,
//     sortQuery: "-createdAt",
//   });
//   const [organizerKeyword, setOrganizerKeyword] = useState("");
//   const organizerSearch = useDebounce(organizerKeyword, 300);

//   const {
//     data: eventData,
//     isLoading: eventLoading,
//     isFetching,
//   } = useQuery({
//     queryKey: ["Event-list", eventFilters, eventSearch],
//     queryFn: async () => {
//       const res = await eventList({
//         ...eventFilters,
//         ...(eventSearch && { keyword: eventSearch }),
//         organization: data?.organization,
//       });
//       if (res?.status !== 200) {
//         toast.warning(res?.message);
//       }
//       return res?.docs;
//     },
//   });

//   const {
//     data: organizersData,
//     isLoading: organizersLoading,
//     isFetching: organizersFetching,
//   } = useQuery({
//     queryKey: ["organization", organizerFilters, organizerSearch],
//     queryFn: async () => {
//       const res = await organizationList({
//         ...organizerFilters,
//         ...(organizerSearch && { keyword: organizerSearch }),
//       });
//       if (res?.status !== 200) {
//         toast.warning(res?.message);
//       }
//       return res?.docs;
//     },
//   });

//   useEffect(() => {
//     return () => {
//       queryClient.removeQueries({ queryKey: ["details", data?._id] });
//     };
//   }, []);

//   const { data: details } = useQuery({
//     queryKey: ["details", data?._id],
//     queryFn: async () => {
//       const res = await collectionDetails({ id: data?._id });
//       return res;
//     },
//     enabled: !!data?._id,
//   });

//   useEffect(() => {
//     if (details?.data?._id) {
//       if (details?.status === 200) {
//         const value = {
//           ...details?.data,
//           name: details?.data?.name?.[lang] || "",
//           description: details?.data?.description?.[lang] || "",
//           logo: details?.data?.logo?.url,
//         };
//         delete value?._id;
//         if (
//           value &&
//           typeof value === "object" &&
//           Object.keys(value)?.length > 0
//         ) {
//           setFieldsValue(value);
//         }
//       }
//     }
//   }, [details?.data?._id, lang]);

//   const { mutate, isPending: isLoading } = useMutation({
//     mutationFn: async (val) => {
//       const payload = {
//         ...val,
//         name: { ...details?.data?.name, [lang]: val?.name },
//         description: {
//           ...details?.data?.description,
//           [lang]: val?.description,
//         },
//         organization: data?.organization,
//         ...(data?._id && { id: data?._id }),
//       };

//       return await collectionAddEdit(payload);
//     },
//     onSuccess: (res) => {
//       if (res?.status === 200 || res?.status === 201) {
//         toast.success(res?.message);
//         getResponse(res);
//         return res;
//       } else {
//         toast.warning(res?.message || res?.error);
//       }
//       return res;
//     },
//     onError: (error) => {
//       console.log(error);
//     },
//   });

//   return (
//     <form onSubmit={(event) => handleSubmit(event, mutate)}>
//       <div className="grid grid-cols-12 gap-x-4 gap-y-4">
//         <div className="col-span-12 px-6 flex items-center justify-center relative">
//           <AvatarUpload
//             src={
//               values?.logo instanceof File
//                 ? URL.createObjectURL(values?.logo)
//                 : values?.logo
//             }
//             onChange={(file) => {
//               handleChange({ target: { name: "logo", value: file } });
//             }}
//             alt="profile"
//             initial={initialsValue(details?.name)}
//           />
//         </div>
//         <div className="col-span-12">
//           <Input
//             label="Name"
//             inputPlaceholder={"Enter Name"}
//             inputName="name"
//             value={values?.name || ""}
//             onChange={handleChange}
//             {...formValidate(errors, "name")}
//           />
//         </div>
//         {/* <div className="col-span-6">
//           <Select
//             placeholder="Select organizers"
//             {...((data?._id || details?._id) && { label: "Select organizers" })}
//             multiple
//             isSearch
//             onSearchHandler={setOrganizerKeyword}
//             dropdownData={organizersData?.data?.map((item) => ({
//               name: item?.name?.[lang] || "",
//               value: item?._id,
//             }))}
//             selectedValue={values?.organization}
//             onChange={(val) => {
//               handleChange({ target: { name: "organization", value: val } });
//             }}
//           />
//         </div>
//         <div className="col-span-6">
//           <Select
//             placeholder="Select events"
//             {...((data?._id || details?._id) && { label: "Select events" })}
//             dropdownData={eventData?.data?.map((item) => ({
//               name: item?.title?.[lang] || "",
//               value: item?._id,
//             }))}
//             selectedValue={values?.events}
//             isSearch
//             onSearchHandler={setEventKeyword}
//             multiple
//             onChange={(val) => {
//               handleChange({ target: { name: "events", value: val } });
//             }}
//           />
//         </div> */}
//         <div className="col-span-12">
//           <Textarea
//             inputValue={values?.description || ""}
//             label="Description"
//             inputName={"description"}
//             onChange={handleChange}
//           />
//         </div>
//       </div>
//       <div className="relative col-span-4 mt-5">
//         <div className="flex items-center justify-center gap-4">
//           <Button
//             buttonType="submit"
//             buttonLabel={"Save Collection"}
//             variant="secondary"
//             {...(isLoading && {
//               loading: true,
//               buttonIconPosition: "left",
//               isDisable: true,
//             })}
//           />
//           <Button
//             buttonLabel={"Cancel"}
//             variant="primary"
//             buttonFunction={close}
//           />
//         </div>
//       </div>
//     </form>
//   );
// }

// const ManageCollection = ({
//   getResponse = () => {},
//   close = () => {},
//   data,
// }) => {
//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const tabs = [
//     {
//       label: "English",
//       content: (
//         <FormComponent
//           getResponse={getResponse}
//           close={close}
//           data={data}
//           lang={"en"}
//         />
//       ),
//     },
//     {
//       label: "Spanish",
//       content: (
//         <FormComponent
//           getResponse={getResponse}
//           close={close}
//           data={data}
//           lang={"es"}
//         />
//       ),
//     },
//   ];

//   return (
//     <div className="h-full p-4">
//       <Tabs
//         items={tabs}
//         setSelectedIndex={setSelectedIndex}
//         selectedIndex={selectedIndex}
//       />
//     </div>
//   );
// };

// export default ManageCollection;

import { useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import AvatarUpload from "../../../common/AvatarUpload";
import Textarea from "../../../form/Textarea";
import { toast } from "react-toastify";
import Tabs from "../../../elements/Tabs";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  collectionAddEdit,
  collectionDetails,
} from "../../../../services/collectionService";
import { initialsValue } from "../../../../helpers";
import { t } from "i18next";

function FormComponent({
  getResponse = () => {},
  close = () => {},
  data,
  lang,
  values,
  handleChange,
  mutate,
  isLoading,
}) {
  const queryClient = useQueryClient();

  const { data: details } = useQuery({
    queryKey: ["details", data?._id],
    queryFn: async () => {
      const res = await collectionDetails({ id: data?._id });
      return res;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    if (details?.data?._id && details?.status === 200) {
      const val = details.data;
      handleChange({
        type: "init",
        payload: {
          name: val?.name,
          description: val?.description,
          logo: val?.logo?.url || null,
        },
      });
    }
  }, [details?.data?._id]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        mutate();
      }}
    >
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="col-span-12 px-6 flex items-center justify-center relative">
          <AvatarUpload
            src={
              values?.logo instanceof File
                ? URL.createObjectURL(values?.logo)
                : values?.logo
            }
            onChange={(file) =>
              handleChange({
                type: "field",
                payload: { name: "logo", value: file },
              })
            }
            alt="profile"
            initial={initialsValue(values?.name?.[lang])}
          />
        </div>
        <div className="col-span-12">
          <Input
            label={t("Name")}
            inputPlaceholder={t("Enter Name")}
            inputName="name"
            value={values?.name?.[lang] || ""}
            onChange={(e) =>
              handleChange({
                type: "localized",
                payload: { field: "name", lang, value: e.target.value },
              })
            }
          />
        </div>
        <div className="col-span-12">
          <Textarea
            inputValue={values?.description?.[lang] || ""}
            label={t("Description")}
            inputName="description"
            onChange={(e) =>
              handleChange({
                type: "localized",
                payload: { field: "description", lang, value: e.target.value },
              })
            }
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={t("Save Collection")}
            variant="secondary"
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={t("Cancel")}
            variant="primary"
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
}

const ManageCollection = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [formValues, setFormValues] = useState({
    name: {},
    description: {},
    logo: null,
  });

  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["details", data?._id] });
    };
  }, []);

  const handleChange = (action) => {
    switch (action.type) {
      case "localized":
        setFormValues((prev) => ({
          ...prev,
          [action.payload.field]: {
            ...prev[action.payload.field],
            [action.payload.lang]: action.payload.value,
          },
        }));
        break;
      case "field":
        setFormValues((prev) => ({
          ...prev,
          [action.payload.name]: action.payload.value,
        }));
        break;
      case "init":
        setFormValues((prev) => ({
          ...prev,
          name: action.payload.name || {},
          description: action.payload.description || {},
          logo: action.payload.logo || null,
        }));
        break;
      default:
        break;
    }
  };

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async () => {
      const payload = {
        ...formValues,
        organization: data?.organization,
        ...(data?._id && { id: data?._id }),
      };
      return await collectionAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        getResponse(res);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (err) => {
      console.error("Error:", err);
    },
  });

  const tabs = [
    { label: "English", lang: "en" },
    { label: "Spanish", lang: "es" },
  ];

  return (
    <div className="h-54 p-4">
      <Tabs
        items={tabs.map((tab) => ({ label: tab.label }))}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />
      <FormComponent
        getResponse={getResponse}
        close={close}
        data={data}
        lang={tabs[selectedIndex].lang}
        values={formValues}
        handleChange={handleChange}
        mutate={mutate}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ManageCollection;
